import React from 'react';

const SvgSo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SO_svg__b" fill="#fff">
        <use xlinkHref="#SO_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#SO_svg__a" />
      <rect
        fill="#5D9FE9"
        mask="url(#SO_svg__b)"
        width={28}
        height={20}
        rx={2}
      />
      <path
        fill="#FFF"
        mask="url(#SO_svg__b)"
        d="M14 12.34l-3.527 2.514 1.302-4.13-3.481-2.578 4.33-.04L14 4l1.375 4.107 4.331.039-3.48 2.577 1.3 4.131z"
      />
    </g>
  </svg>
);

export default SvgSo;
